export default __webpack_public_path__ + "static/media/mail-grey.e30f6a0e.svg";